<template>
  <div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mb-4 flex flex-wrap items-center justify-end">
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelar">Volver</vs-button>
        </div>
      </div>
    </div>

    <vx-card card-border title="Comentarios de la operación" title-color="dark" collapseAction>
      <div v-if="timelineData.length>0">
        <ul class="vx-timeline">
          <li v-for="item in timelineData" :key="item.id">
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-11/12 w-full">
                <div class="timeline-icon" :class="`bg-${item.color}`">
                    <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
                </div>
                <div class="timeline-info fondoComentario">
                  <div class="mb-2">
                    <p class="textoOperacionComentarioDateTime">{{ item.time }}</p>
                  </div>
                  <div class="mb-2">
                    <p class="textoOperacionComentarioProducto">{{ item.title }}</p>
                  </div>
                  <div class="mb-2">
                    <span class="textoOperacionComentario">{{ item.desc }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col sm:w-1/12 w-full">
                &nbsp;
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else>
        <vs-alert color="danger" icon-pack="feather" icon="icon-info">
          <span>No se ha creado ningún comentario asociado a la operación.</span>
        </vs-alert>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-4 flex flex-wrap items-center justify-end">
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelar">Volver</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

export default {
  name: 'OperacionesViewComentarios',
  components: {},
  data () {
    return {
      usuario: null,
      operacion: {},
      comentarios: {},
      productos: {},
      producto: null,
      comentario: null
    }
  },
  computed: {
    timelineData () {
      const c = []
      this.comentarios.forEach(element => {
        const e = {}
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }
        e.id = element.id
        e.borrar = element.usuario.id === this.usuario.uid 
        e.color = element.producto ? 'success' : 'warning'
        e.icon = element.producto ? 'ShoppingCartIcon' : 'BookOpenIcon'
        e.title = element.producto ? element.producto.producto : '---'
        e.desc = element.comentario
        e.time = `${new Date(element.fecha).toLocaleDateString('es-ES', options)} por ${element.usuario.apellidos}, ${element.usuario.nombre}`
        c.push(e)
      })
      return c
    }
  },
  methods: {
    cancelar () {
      this.$router.push({name: 'operaciones'})
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.comentarios = JSON.parse(JSON.stringify(this.operacion.comentarios))
    this.comentarios.sort((a, b) => { return new Date(b.fecha) - new Date(a.fecha)})
    this.usuario = JSON.parse(sessionStorage.getItem('userInfo'))
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>